export default __webpack_public_path__ + "static/media/dapat-light.49e27eb9.svg";